const doc = [({"zh_cn":({"adminComponentAdminTop":({"firstHotelRegistrationMessage":"请注册该设施。 {{num}} 您可以注册该设施。"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;